import { type RouteLocationRaw } from "vue-router";

export type Breadcrumb = {
  text: string | (() => string);
  to?: RouteLocationRaw;
};

export type BreadcrumbWithDynamicText = Breadcrumb & {
  text: () => string;
};

const breadcrumbs = ref<Breadcrumb[]>([]);

export function useBreadcrumbs() {
  const clear = () => (breadcrumbs.value = []);

  const add = (breadcrumb: Breadcrumb) => breadcrumbs.value.push(breadcrumb);

  const set = (newBreadcrumbs: Breadcrumb[]) => (breadcrumbs.value = newBreadcrumbs);

  const hasDynamicText = (breadcrumb: Breadcrumb): breadcrumb is BreadcrumbWithDynamicText => typeof breadcrumb.text === "function";

  return {
    breadcrumbs,
    clear,
    add,
    set,
    hasDynamicText,
  };
}
